import { Box, Text } from "@mantine/core";
import {
  reportTitleBarStyle,
  reportTitleTextStyle,
} from "./DocumentHeaderStyles";

interface ReportNotificationBannerProps {
  label: string;
}

export function ReportNotificationBanner({
  label,
}: ReportNotificationBannerProps) {
  return (
    <Box
      data-report-supplement-banner={label}
      style={{
        ...reportTitleBarStyle,
        marginTop: "8pt",
        marginBottom: "8pt",
        width: "100%",
      }}
    >
      <Text style={reportTitleTextStyle}>{label}</Text>
    </Box>
  );
}
